import React from 'react';
import { Card } from "react-bootstrap";
import face_tamas_ormandi from "../../assets/img/face_tamas_ormandi.png";
import ShowMoreText from "react-show-more-text";
import proj_pca_GP_mesoscopic_V2X from "../../assets/img/proj_pca_GP_mesoscopic_V2X.png";

const Tamas_Ormandi_PCA_V2X = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_pca_GP_mesoscopic_V2X} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_tamas_ormandi}
              /* this will be the text on the banner */
              alt="PCA and Gaussian Process for mesoscopic V2X simulation in road traffic"
            />{" "}
            <p className="text7">Tamás Ormándi</p>
            <br />
            <p className="text8">
              PhD student{" "}
            </p>
            <p className="text8">BME Traffic Lab</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Mesoscopic simulation of V2X communication of road traffic requires aggregating 
            the frequency of sending Cooperative Awareness Messages. This way, the communication 
            of an entire area's traffic can be aggregated, and simulation performance can be 
            enhanced. The task is to apply PCA on a V2X simulation dataset containing the primary 
            parameters of the CAM generation standard. A Gaussian Process must be trained for the 
            frequency estimation with the reduced dataset with the highest possible accuracy.

            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                <a href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4695627">Ormándi, Tamás and 
                Varga, Balázs, Mesoscopic V2X Simulation Framework to Enhance Simulation Performance.</a>
                </li>
                <li>
                <a href="https://ieeexplore.ieee.org/document/8569938">P. A. Lopez et al., "Microscopic 
                Traffic Simulation using SUMO," 2018 21st International Conference on Intelligent 
                Transportation Systems (ITSC), Maui, HI, USA, 2018, pp. 2575-2582</a>
                </li>
                <li>
                <a href="https://ieeexplore.ieee.org/document/5510240">C. Sommer, R. German and F. 
                Dressler, "Bidirectionally Coupled Network and Road Traffic Simulation for Improved 
                IVC Analysis," in IEEE Transactions on Mobile Computing, vol. 10, no. 1, pp. 3-15, Jan. 2011</a>
                </li>
            </ul>
            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Tamas_Ormandi_PCA_V2X;